export default __webpack_public_path__ + "static/media/blukey.e5d3d29b.svg";